module.exports = __webpack_public_path__ + "static/media/bi_winner_emblem_black.d34fac8b.png";